// extracted by mini-css-extract-plugin
module.exports = {"Form":"Inputs_Form__24aIe","select":"Inputs_select__13DB_","dismiss":"Inputs_dismiss__1nVVS"};